import { useMutation, useQueryClient } from '@tanstack/react-query';
import updateSRTTrunk from 'API/SRT/updateSRTTrunk';

/**
 * Updates an SRT trunk's name and channels.
 *
 * @returns TanStack mutation taking `{ id, name, channels }`.
 */
const useUpdateSRTTrunk = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, name, channels }) =>
            updateSRTTrunk({ id, name, channels }),
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: ['srtTrunk', id] });
            queryClient.invalidateQueries({ queryKey: ['getSRTTrunks'] });
        },
    });
};

export default useUpdateSRTTrunk;
